import { TableSkeleton } from '@components';
import React, { ChangeEvent, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import NetworkSpeedTestHistory from '../../../components/charts/stats/NetworkSpeedtestHistory';
import SearchTable from '../../../components/inputs/search/SearchTable';
import NetworkDevicesTable from '../../../components/tables/NetworkDevicesTable';
import TableWrapper from '../../../components/tables/TableWrapper';
import { useSearchFilter } from '../../../hooks/useSearchFilter';
import {
  DomotzDevice,
  DomotzDeviceList,
  DomotzDeviceSearchableKeys,
  DomotzFullDeviceRequest,
  DomotzSpeedTest,
  DomotzTopology,
} from '../../../interfaces/NetworkDevices';
import { NetworkDevicesService } from '../../../services/assets/NetworkDevices';
import { RootState } from '../../../state/store';

export const NetworkDevicesContainer = () => {
  const [networkDevices, setNetworkDevices] = useState<DomotzDeviceList>([]);
  const [networkTopology, setNetworkTopology] = useState<DomotzTopology[]>([]);
  const [networkSpeedTest, setNetworkSpeedTest] = useState<DomotzSpeedTest>();
  const networkDevicesService = new NetworkDevicesService();
  const companyId = useSelector(
    (state: RootState) => state.companies.selectedCompany?.id
  );

  if (!companyId) {
    return <div>Error</div>;
  }

  const getNetworkDevices = async () => {
    const result = await networkDevicesService.getNetworkDevices(companyId);
    const devices = enrichDevicesWithTopology(result.devices);
    setNetworkDevices(result.devices.devices);
    setNetworkTopology(result.devices.topology);
  };

  const getSpeedtestHistory = async () => {
    const result = await networkDevicesService.getSpeedtestHistory(companyId);
    setNetworkSpeedTest(result);
  };

  function enrichDevicesWithTopology(
    data: DomotzFullDeviceRequest
  ): DomotzFullDeviceRequest {
    const { devices, topology } = data;

    const deviceMap = new Map<number, DomotzDevice>(
      devices.map((dev) => [dev.id, dev])
    );

    devices.forEach((dev) => {
      dev.connected_to = [];
      dev.uplink = [];
    });

    topology.edges.forEach((edge) => {
      const fromDevice = deviceMap.get(edge.from);
      const toDevice = deviceMap.get(edge.to);

      if (fromDevice) {
        fromDevice.connected_to!.push(edge.to);
      }

      if (toDevice) {
        const fromDevice = deviceMap.get(edge.from);
        if (fromDevice) {
          toDevice.uplink!.push({
            id: fromDevice.id,
            display_name: fromDevice.display_name,
            type: fromDevice.type.label,
          });
        }
      }
    });

    return data;
  }

  const searchableKeys: Partial<DomotzDeviceSearchableKeys>[] = [
    'display_name',
    'vendor',
    'status',
    'ip_addresses',
  ];
  const { filteredData, searchQuery, setSearchQuery } = useSearchFilter(
    networkDevices,
    searchableKeys,
    'display_name'
  );

  useEffect(() => {
    getNetworkDevices();
    getSpeedtestHistory();
  }, []);

  return (
    <div>
      {networkDevices ? (
        <TableWrapper>
          <SearchTable
            handleChange={(e: ChangeEvent<HTMLInputElement>) =>
              setSearchQuery(e.target.value)
            }
            search={searchQuery}
            placeholder="Zoeken"
          />

          <NetworkDevicesTable devices={filteredData} />
        </TableWrapper>
      ) : (
        <TableSkeleton />
      )}

      {networkSpeedTest?.history && (
        <NetworkSpeedTestHistory history={networkSpeedTest.history} />
      )}
    </div>
  );
};

export default NetworkDevicesContainer;
